import React, {useState} from 'react'

import useAppStore from '../../../useAppStore';

import './contact.css'; 


const Contact = ({ open, setOpen, title }) => {
    const { isViewOpen, closeView } = useAppStore(); // Access state and actions from the store

    const [status, setStatus] = useState("");

    const [contactFormData, setContactFormData] = useState({
      fullName: '',
      email: '',
      phone: '',
      message: '',
      subscribe: false
    });
  
const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  setContactFormData({ 
    ...contactFormData, 
    [name]: type === 'checkbox' ? checked : value
  });
}

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const response = await fetch("http://localhost:3810/api/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactFormData),
    });

    const result = await response.json();
    if (result.success) {
      setStatus("Message sent successfully!");
      setContactFormData({ name: "", email: "", message: "" });
    } else {
      setStatus("Failed to send message.");
    }
  } catch (error) {
    setStatus("Error sending message.");
  }
};

  return ( 
    <div> 
      <div className="letsChat mt-8 max-w-md ml-4">Lets Chat!</div> 
      <div className="contactFormContainer">
          
        <label htmlFor='fullName' className='label'><span>Full name</span> </label>
        <input id='fullName' name='fullName' type="text" className="" placeholder="John Smith" onChange={handleChange} value={contactFormData.fullName} />
          
        <label htmlFor='email' className='label'> <span>Email address</span> </label>
        <input id='email' name='email' type="email" className="" placeholder="John@example.com" onChange={handleChange} value={contactFormData.email} />
        
        <label htmlFor='phone' className='label'> <span>Phone</span> </label>
        <input id='phone' name='phone' type="phone" className="" placeholder="555-867-5309" onChange={handleChange} value={contactFormData.phone} />
      
        <label htmlFor='message' className='label'> <span>Message</span> </label>
        <textarea id='message' name='message' className="" rows="2" placeholder="Tell me, what's on your mind?" onChange={handleChange} value={contactFormData.message} ></textarea>
        
      </div> 

      <div className='bottomHalfContact'>
          <button className='submitButton' onClick={handleSubmit}>Submit</button>
          <div className="mt-2">
            <div>
              <label htmlFor='subscribe' className="inline-flex items-center">
                <input id='subscribe' name='subscribe' type="checkbox" className="border-gray-300 border-2 text-black focus:border-gray-300 focus:ring-black" onChange={handleChange} checked={contactFormData.subscribe} />
                <span className="ml-2">Email me news</span>
              </label>
            </div>
          </div>
          <a href='https://www.linkedin.com/in/luis-raffucci-720084315/'>
            <svg  xmlns="http://www.w3.org/2000/svg" 
                  x="0px" 
                  y="0px" 
                  width="50" 
                  height="50" 
                  viewBox="0 0 50 50"
                  style={{ fill:"#1A1A1A" }}>
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
              </svg>
          </a>
        </div>
    </div>
  );
}

export default Contact;
